var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0621 0.909507C10.3843 0.0388889 11.6157 0.0388879 11.9379 0.909506L14.0815 6.70267C14.1828 6.97639 14.3986 7.1922 14.6723 7.29348L20.4655 9.43715C21.3361 9.75931 21.3361 10.9907 20.4655 11.3129L14.6723 13.4565C14.3986 13.5578 14.1828 13.7736 14.0815 14.0473L11.9379 19.8405C11.6157 20.7111 10.3843 20.7111 10.0621 19.8405L7.91848 14.0473C7.8172 13.7736 7.60139 13.5578 7.32767 13.4565L1.53451 11.3129C0.663889 10.9907 0.663888 9.75931 1.53451 9.43715L7.32767 7.29348C7.60139 7.1922 7.8172 6.97639 7.91848 6.70267L10.0621 0.909507Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.1bed31962edd08d484dd968ed279f2d1.svg";
export { ForwardRef as ReactComponent };